import React from 'react';
import Div from '../Div';
import './logolist.scss';
const partnerLogos = [
  {
    src: '/images/logo 1.png',
    alt: 'Partner',
  },
  {
    src: '/images/logo 2.png',
    alt: 'Partner',
  },
  {
    src: '/images/logo 3.png',
    alt: 'Partner',
  },
  {
    src: '/images/logo 4.png',
    alt: 'Partner',
  },
  {
    src: '/images/logo 5.png',
    alt: 'Partner',
  },
];

export default function LogoList() {
  return (
    <Div className="cs-partner_logo_wrap">
      {partnerLogos.map((partnerLogo, index) => (
        <div className="cs-partner_logo" key={index}>
          <img src={partnerLogo.src} alt={partnerLogo.alt} />
        </div>
      ))}
    </Div>
  );
}
